export default __webpack_public_path__ + "static/media/icon_add.2f8abc6a.svg";